export const transliterate = async (text: string, lang: string) => {
  try {
    const res = await fetch(
      `https://inputtools.google.com/request?text=${encodeURIComponent(
        text
      )}&itc=${lang}-t-i0-und&num=1`
    );

    const data = await res.json();

    if (data[0] === "SUCCESS") {
      return data[1][0][1][0];
    }

    return text;
  } catch {
    return text;
  }
};